import styled from 'styled-components'

export const BackButtonContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.5rem;
  gap: 1rem;
  background-color: ${(props) => props.theme.color.blue.blue50};
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;

  &::after {
    content: '';
    background: ${(props) => props.theme.color.purple.purple800};
    display: block;
    position: absolute;
    padding-top: 10%;
    padding-left: 10%;
    border-radius: 50%;
    margin-left: -40px !important;
    opacity: 0;
    transition: all 0.5s;
  }

  &:active::after {
    padding: 0;
    margin: 0;
    opacity: 0.5;
    transition: 0s;
  }
`

export const BackButtonIcon = styled.div`
  border-radius: 50%;
  width: 0.875rem;
  height: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;

  &:active {
  }
`

export const BackButtonText = styled.div`
  color: ${(props) => props.theme.color.purple.purple800};
  font-size: ${(props) => props.theme.font.textoverline};
`
